import { Application } from "@components/application";
import React from "react";
import ReactDOM from "react-dom/client";

import moment from "moment";
import "moment/locale/id";

import "@assets/css/style.css";
import "@assets/css/font.css";
import "@assets/css/custom/card.css";
import "@assets/css/custom/button.css";
import "@assets/css/custom/modal.css";
import "@assets/css/custom/tab.css";
import "@assets/css/custom/carousel.css";
import "@assets/css/custom/top-nav.css";

moment.locale("id");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>
);
